import Analytics from '.';
import axios from 'axios';
import { ENDPOINTS } from '@/settings/endpoints';
import { getDexToken } from '../get-tokens';

export class UndergradAnalytics extends Analytics {
  static async updateHubSpotContactProperties(
    properties: Record<string, string | number | boolean>,
  ): Promise<void> {
    const dexToken = getDexToken();

    await axios.put(
      '/hubspot/contacts',
      { properties },
      {
        baseURL: ENDPOINTS.pegasusEpona,
        headers: {
          'Authorization-Dex': `Bearer ${dexToken}`,
        },
      },
    );
  }
}
